import { createElementBlock as t, openBlock as e, createElementVNode as o } from "vue";
import r from "./index289.js";
const n = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(l, a, m, p, i, L) {
  return e(), t("svg", s, a[0] || (a[0] = [
    o("path", {
      fill: "currentColor",
      d: "M17.945 3.055c.344.344.577.757.701 1.194L21 4.25a.75.75 0 0 1 .102 1.493L21 5.75h-2.354a2.75 2.75 0 0 1-5.293 0H3a.75.75 0 0 1-.102-1.493L3 4.25h10.354a2.75 2.75 0 0 1 4.59-1.194Zm-2.829 1.061a1.25 1.25 0 1 0 1.859.102l-.091-.102-.102-.091a1.25 1.25 0 0 0-1.666.091Zm-5.171 5.94c.344.343.577.756.701 1.193L21 11.25a.75.75 0 0 1 .102 1.493L21 12.75H10.646a2.75 2.75 0 0 1-5.293 0H3a.75.75 0 0 1-.102-1.493L3 11.25h2.354a2.75 2.75 0 0 1 4.59-1.194Zm-2.829 1.06a1.25 1.25 0 1 0 1.859.102l-.091-.102-.102-.091a1.25 1.25 0 0 0-1.666.091Zm10.829 5.94c.344.343.577.756.701 1.193L21 18.25a.75.75 0 0 1 .102 1.493L21 19.75h-2.354a2.75 2.75 0 0 1-5.293 0H3a.75.75 0 0 1-.102-1.493L3 18.25h10.354a2.75 2.75 0 0 1 4.59-1.194Zm-2.829 1.06a1.25 1.25 0 1 0 1.859.102l-.091-.102-.102-.091a1.25 1.25 0 0 0-1.666.091Z"
    }, null, -1)
  ]));
}
const d = /* @__PURE__ */ r(n, [["render", c]]);
export {
  d as default
};
